import React, { useCallback } from "react"
import { useSelector } from 'react-redux'
import { useTranslation } from "react-i18next"
import { Link, useParams } from "react-router-dom"
import './main.scss'
import { Dropdown } from "react-bootstrap"


const ModeToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
        ref={ref}
        href=""
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
        style={{padding:"1rem 0"}}
    >
      {children}
    </a>
  ));

const BreadCrumb = () => {
    const {t, i18n} = useTranslation()
    const {mode, buildingCode, systemCode, postCode} = useParams()

    const {building} = useSelector(state => ({
        building: state.building.entity
    }))

    const renderMode = useCallback(() => {
        return (<li className="breadcrumb-item">
                    <Dropdown>
                        <Dropdown.Toggle as={ModeToggle}>
                            {t(`common.mode.${mode}`)}
                        </Dropdown.Toggle>
                        <Dropdown.Menu variant="dark">
                            <Dropdown.Item as={Link} to={`/daily`}>{t(`common.mode.daily`)}</Dropdown.Item>
                            
                            <Dropdown.Item as={Link} to={`/energy`}>{t(`common.mode.energy`)}</Dropdown.Item>
                            
                            <Dropdown.Item as={Link} to={`/disaster`}>{t(`common.mode.disaster`)}</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </li>)
    },[mode])

    const renderBuilding = useCallback(() => {
        if(buildingCode && building && buildingCode == building.building_code){
            const name = i18n.language == 'en' ? building.building_name_en.toLowerCase() : building.building_name_tc
            const url = `/${mode}/building/${buildingCode}`
            return <li className="breadcrumb-item"><Link to={url} className="building">{name}</Link></li>
        }
    },[buildingCode, building])

    const renderSystem = useCallback(() => {
        const buildingPath = buildingCode ? `/building/${buildingCode}` : ``
        if(systemCode){
            const systemPath = `/system/${systemCode}`
            const url = `/${mode}${buildingPath}${systemPath}`
            return <li className="breadcrumb-item"><Link to={url}>{t(`common.system.${systemCode}`)}</Link></li>
        }else{
            const url = `/${mode}${buildingPath}`
            return <li className="breadcrumb-item"><Link to={url}>{t(`common.system.overview`)}</Link></li>
        }
    },[systemCode])

    const renderPost = useCallback(() => {
        if(postCode){
            const postPath = postCode ? `/post/${postCode}`: ``
            const url = `/${mode}${postPath}`
            return <li className="breadcrumb-item"><Link to={url}>{postCode}</Link></li>
        }
    }, [postCode])
    
    return (
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
                {renderMode()}
                {renderBuilding()}
                {renderPost()}
                {renderSystem()}
                
            </ol>
        </nav>
    )
}

export default BreadCrumb